<script setup>
import { ToastProvider } from 'radix-vue'
import { defineProps } from 'vue'
const props = defineProps({
  swipeDirection: { type: String, default: 'right' },
  swipeThreshold: { type: Number, default: 50 },
  label: { type: String, default: 'Notification' }
})
</script>

<template>
  <ToastProvider v-bind="props">
    <slot />
  </ToastProvider>
</template> 